/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetBadgeCategoryDataDto
 */
export interface GetBadgeCategoryDataDto {
    /**
     * 뱃지 카테고리 id
     * @type {number}
     * @memberof GetBadgeCategoryDataDto
     */
    'badgeCategoryId': number;
    /**
     * 종류
     * @type {string}
     * @memberof GetBadgeCategoryDataDto
     */
    'type': GetBadgeCategoryDataDtoTypeEnum;
    /**
     * 설명
     * @type {string}
     * @memberof GetBadgeCategoryDataDto
     */
    'description': string;
    /**
     * 보너스 포인트
     * @type {number}
     * @memberof GetBadgeCategoryDataDto
     */
    'bonusPoint': number;
}

export const GetBadgeCategoryDataDtoTypeEnum = {
    StartViewup: 'start_viewup',
    SavingJoy: 'saving_joy',
    Reach10000P: 'reach_10,000P',
    AchieveInstallationReview: 'achieve_installation_review',
    AchievePostingReview: 'achieve_posting_review',
    ViewupHolic: 'viewup_holic',
    WritingFun: 'writing_fun',
    SympathyKing: 'sympathy_king',
    CommentKing: 'comment_king'
} as const;

export type GetBadgeCategoryDataDtoTypeEnum = typeof GetBadgeCategoryDataDtoTypeEnum[keyof typeof GetBadgeCategoryDataDtoTypeEnum];


